import Vue from 'vue';
import Component from 'vue-class-component';
import common = require('../../common');
import utilities = require('../utilities');

//declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');
//var jsClasses = require('../../js/jsClasses');

interface INotification {
    message: common.IMessage,
    isHidden?: boolean
}

// The @Component decorator indicates the class is a Vue component
@Component
class NotificationsVue extends Vue {

    totalUnread = 0;
    items = [] as INotification[];
    isOpen = false;

    private $initialData: any;
    private _rootId: string;
    private _onClickCallback = null as () => void;
    private _onItemClickCallback = null as (message: common.IMessage) => void;
    private _onDeleteAllClickCallback = null as () => void;
    private _onDeleteItemClickCallback = null as (message: common.IMessage) => void;
    private _onItemLinkClickCallback = null as (message: common.IMessage) => void;

    beforeCreate() {
        this._rootId = this.$initialData.vueElId;
        this.$options.el = '#' + this._rootId;
    }

    created() {
    }

    mounted() {

        // permet de fermer la popup lors du click a l'exterieur
        document.addEventListener("mousedown", e => {
            if (!this.isOpen)
                return;
            const currentEl = e.target as Element;
            const el = this.$el as Element;
            if (utilities.isOutside(currentEl, el)) {
                const popupElements = document.getElementsByClassName("mn-menu");
                if (popupElements.length) {
                    const popupEl = popupElements[0];
                    if (utilities.isOutside(currentEl, popupEl))
                        this.open(false);
                }
                return;
            }
        });
    }

    setTotalUnread(value?: number) {
        this.totalUnread = value || 0;
        return this;
    }

    hasUnreadNotifications() {
        return !!this.totalUnread;
    }

    hasNotifications() {
        if (this.items)
            for (let i = 0; i < this.items.length; i++) {
                const x = this.items[i];
                if (x.isHidden !== true)
                    return true;
            }

        return false;
    }

    formatTotalUnread(value?: number, max?: number) {
        value = value || 0;
        max = max || 99;
        return value < max
            ? value
            : '<span class="too-higher">{n}+</span>'.replace("{n}", max.toString());
    }

    formatTotalUnreadToolTip(value?: number) {

        if (!value)
            return "";

        return value === 1
            ? "Vous avez 1 notification"
            : "Vous avez {n} notifications".replace("{n}", value.toString());
    }

    setOnClickCallback(callback: () => void) {
        if (callback)
            this._onClickCallback = callback;
        return this;
    }
    setOnItemClickCallback(callback: (message: common.IMessage) => void) {
        if (callback)
            this._onItemClickCallback = callback;
        return this;
    }
    setOnDeleteAllClickCallback(callback: () => void) {
        if (callback)
            this._onDeleteAllClickCallback = callback;
        return this;
    }
    setOnDeleteItemClickCallback(callback: (message: common.IMessage) => void) {
        if (callback)
            this._onDeleteItemClickCallback = callback;
        return this;
    }
    setOnItemLinkClickCallback(callback: (message: common.IMessage) => void) {
        if (callback)
            this._onItemLinkClickCallback = callback;

        return this;
    }


    onClick(event?: Event) {
        if (event)
            event.preventDefault();

        if (this._onClickCallback)
            this._onClickCallback();
    }

    onItemClick(event: Event, item: INotification) {
        if (event)
            event.preventDefault();

        if (this._onItemClickCallback)
            this._onItemClickCallback(item.message);
    }

    onItemLinkClick(event: Event, message: common.IMessage) {
        if (event)
            event.preventDefault();

        if (this._onItemLinkClickCallback)
            this._onItemLinkClickCallback(message);
    }

    setMessageStatusAsRead(messageIds: string[]) {
        this.setMessageStatus(common.MessageStatusTypes.read, messageIds);
        return this;
    }

    setMessageStatusAsDeleted(messageIds: string[]) {
        const updatedMessages = this.setMessageStatus(common.MessageStatusTypes.deleted, messageIds);
        this.hideMessages(updatedMessages);
        return this;
    }

    setAllMessagesStatusAsDeleted() {
        const updatedMessages = this.setMessageStatus(common.MessageStatusTypes.deleted);
        this.hideMessages(updatedMessages);
        return this;
    }

    private hideMessages(messages: INotification[]) {
        for (let i = 0; i < messages.length; i++)
            messages[i].isHidden = true;
    }

    private setMessageStatus(status: common.MessageStatusTypes, messageIds?: string[]) {
        const updateAll = !messageIds;
        const r = [] as INotification[];
        const containsId = (id: string) => {
            for (let i = 0; i < (messageIds || []).length; i++)
                if (messageIds[i] === id)
                    return true;
            return false;
        }
        for (let i = 0; i < (this.items || []).length; i++) {
            const x = this.items[i];
            if (updateAll || containsId(x.message.id)) {
                x.message.messageStatus = status;
                r.push(x);
                if (!updateAll)
                    return r;
            }
        }
        return r;
    }

    onDeleteAllClick(event: Event) {

        if (event)
            event.preventDefault();

        if (this._onDeleteAllClickCallback)
            this._onDeleteAllClickCallback();
    }

    onDeleteItemClick(event: Event, item: INotification) {

        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this._onDeleteItemClickCallback)
            this._onDeleteItemClickCallback(item.message);
    }

    setItems(messages: common.IMessage[], reset?: boolean) {
        reset = reset === true;//default is FALSE

        const notifications = [] as INotification[];
        const updatedMessageIds = [] as string[];
        const appendId = (x: INotification) => {
            if (x.message.id)
                updatedMessageIds.push(x.message.id);
        };

        (messages || []).forEach(x => notifications.push({
            message: x,
            isHidden: false
        } as INotification));

        if (reset) {
            notifications.forEach(appendId);
            this.items = notifications;
            return updatedMessageIds;
        }

        const get = (id: string) => {
            if (id)
                for (let i = 0; i < this.items.length; i++) {
                    const x = this.items[i];
                    if (x.message.id === id)
                        return {
                            index: i,
                            item: x
                        };
                }
            return null;
        };

        for (let i = 0; i < notifications.length; i++) {
            const a = notifications[i];
            const b = get(a.message.id);
            if (b) {
                this.items[b.index] = b.item;
                continue;
            }
            appendId(a);
            this.items.unshift(a);//prepend
        }
        return updatedMessageIds;
    }

    /** Ouvre/ferme la popup */
    open(isOpen?: boolean) {
        isOpen = isOpen !== false;

        if (isOpen !== this.isOpen)
            this.isOpen = isOpen;

        return this;
    }
}

export = NotificationsVue;